import React, { useMemo } from 'react';
import { Box, Divider, Grid, Paper, Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { IdPropType } from '../../../proptypes/basic';
import { useEmail } from '../emailsSlice';
import { formatDate } from '../../date/utils';
import MailContacts from './MailContacts';
import MailAttachments from './MailAttachments';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: '20px auto',
        background: '#fff',
        maxWidth: '900px',
    },

    mailMeta: {
        marginBottom: theme.spacing(2),
    },

    mailText: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        whiteSpace: 'pre-line',
    },

    empty: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));
const MailContent = ({ mailId }) => {
    const classes = useStyles();
    const [mail] = useEmail(mailId);

    const iframe = document.createElement('iframe');
    const isHtmlEmailSupported = 'sandbox' in iframe && 'srcdoc' in iframe;

    const htmlContent = useMemo(() => {
        const whiteSpace = /<\/?[a-z][\s\S]*>/i.test(mail?.body || '') ? 'normal' : 'pre-wrap';

        return `
    <html>
      <head>
        <meta http-equiv="Content-Security-Policy" content="script-src 'none'">
        <base target="_blank">
        <style>
          body {
            margin: 0;
            overflow-y: hidden;
            color: #212529;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
            font-size: 14px;
            font-weight: 400;
            line-height: 1.5;
            white-space: ${whiteSpace};
          }
          html:not(.x), body:not(.x) {
            height: auto !important;
          }
          p:first-child { margin-top: 0; }
          p:last-child { margin-bottom: 0; }
          a[href] { color: #3781B8; text-decoration: none; }
          a[href]:hover { text-decoration: underline; }
          blockquote[type=cite] {
            margin: 0 0 0 .8ex;
            border-left: 1px solid #ccc;
            padding-left: 1ex;
          }
          img { max-width: 100%; }
          ul, ol { padding: 0; margin: 0 0 10px 25px; }
          ul { list-style-type: disc; }
        </style>
      </head>
      <body>${mail?.body}</body>
    </html>
  `;
    }, [mail]);

    return (
        <Paper elevation={1} className={classes.root}>
            {mail ? (
                <>
                    <Grid className={classes.mailMeta}>
                        <Grid container justify="space-between">
                            <Grid item>
                                <MailContacts mailId={mailId} />
                            </Grid>
                            <Typography color="textSecondary" gutterBottom>
                                {formatDate(mail.received_at, 'DD.MM.YYYY HH:mm')}
                            </Typography>
                        </Grid>
                        <Typography variant="h4">{mail.subject}</Typography>
                    </Grid>
                    <Divider />
                    <MailAttachments mailId={mailId} />
                    <Divider />
                    {isHtmlEmailSupported ? (
                        <Box sx={{ width: '100%' }}>
                            <iframe
                                title="mail content"
                                style={{ width: '100%', border: 0, marginTop: '5px' }}
                                onLoad={(e) => {
                                    const iframe = e.currentTarget;
                                    const iframeDocument =
                                        iframe.contentDocument || iframe.contentWindow?.document;
                                    if (iframeDocument) {
                                        const newHeight = iframeDocument.body.scrollHeight;
                                        iframe.style.height = `${newHeight}px`;
                                    }
                                }}
                                srcDoc={htmlContent}
                                sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin"
                                csp="script-src 'none'"
                                className="h-full w-full"
                            />
                        </Box>
                    ) : (
                        <div>Ihr Browser wird nicht unterstützt</div>
                    )}
                    {/*
	                    <Typography
	                        className={classes.mailText}
	                        variant="body1"
	                        dangerouslySetInnerHTML={{ __html: mail.body }}
	                    />
                    */}
                </>
            ) : (
                <Typography
                    variant="h3"
                    component="h3"
                    className={classes.empty}
                    color="textSecondary"
                >
                    Keine E-Mail ausgewählt.
                </Typography>
            )}
        </Paper>
    );
};

MailContent.propTypes = {
    mailId: IdPropType,
};

MailContent.defaultProps = {
    mailId: null,
};

export default MailContent;
